import React, { useEffect, useMemo, useState } from 'react'
import { trans } from 'sharedKernel/i18n'
import { DEFAULT_OPPORTUNITY_IMAGE } from 'domain/feature/hub/company/scouting/FormWrapper/list/constants'
import type { ScoutingOpportunity } from 'domain/feature/hub/company/scouting/api/scoutingService'
import { getOpportunityCoverImage } from 'domain/feature/hub/company/scouting/scoutingOpportunityDisplay'
import { CoverBanner, CoverBannerWrapper } from '../ScoutingAbout/styles'

interface ScoutingDetailCoverProps {
  data: ScoutingOpportunity | null | undefined
}

export const ScoutingDetailCover = ({ data }: ScoutingDetailCoverProps): JSX.Element => {
  const defaultCoverSrc = useMemo(() => getOpportunityCoverImage(data), [data])
  const [coverSrc, setCoverSrc] = useState(defaultCoverSrc)

  useEffect(() => {
    setCoverSrc(defaultCoverSrc)
  }, [defaultCoverSrc])

  return (
    <CoverBannerWrapper>
      <CoverBanner
        src={coverSrc}
        alt={data?.title ?? trans('scouting.about.coverAlt')}
        onError={() => setCoverSrc(DEFAULT_OPPORTUNITY_IMAGE)}
      />
    </CoverBannerWrapper>
  )
}
